import { Amplify } from 'aws-amplify';
import { getCurrentUser, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { useEffect } from 'react';
import { useLocalStorage } from './useStorageManage';

import awsconfig from '@/amplifyconfiguration.json';
import { STORAGE_KEYS } from '@/const/key-stores';
import { stringUtils } from '@/utils/stringUtils';

awsconfig.oauth.redirectSignIn = window.location.origin + window.location.pathname;
awsconfig.oauth.redirectSignOut = window.location.origin + window.location.pathname;
Amplify.configure(awsconfig);

/**
 * 認証に関する処理をまとめたHooks。
 * @returns
 */
export const useAmplifyAuth = () => {
  const { setStorageItem } = useLocalStorage();
  const { upperStartStr, startWith } = stringUtils;

  /**
   * ログイン処理をする。
   */
  const authentication = async () => {
    const isAuth = await isAuthenticated();
    const queryString = window.location.search;

    if (queryString !== '') {
      setStorageItem(STORAGE_KEYS.QUERY_STRING, queryString);
    }

    if (!isAuth) {
      signInWithRedirect({
        provider: { custom: 'LINE' }
      });
    }
  };
  useEffect(() => {
    authentication();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * ログイン中のユーザのユーザを取得する。
   * ログイン済みで無い（セッションが切れている場合）場合、ログアウト処理をする。
   * @returns ユーザセッション
   */
  const getUser = async () => {
    try {
      return await getCurrentUser();
    } catch (e) {
      await signOut();
      return undefined;
    }
  };

  /**
   * ログイン中のユーザのLINEIDを取得する。
   * @returns LINEユーザID
   */
  const getLineUserId = async () => {
    const user = await getUser();
    if (!user) return undefined;
    const userName = user.username;
    if (startWith(userName, 'line_u')) return upperStartStr(userName.slice(5));

    return undefined;
  };

  /**
   * ログイン済みかチェックする。
   * @returns true：認証済み
   */
  const isAuthenticated = async () => {
    const user = await getUser();
    if (user) return true;
    else return false;
  };

  return { getLineUserId, isAuthenticated };
};
